import Vue from 'vue'
import cookie from 'vue-cookie'

Vue.use(cookie)